import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { dominioEmpresaBeneficiosContratacao, dominioEmpresaBeneficiosContratacaoWebp, dominioEmpresaBeneficiosConvite, dominioEmpresaBeneficiosConviteWebp, dominioEmpresaCobrancasContratacao, dominioEmpresaCobrancasContratacaoWebp, dominioEmpresaContabilidadeContratacao, dominioEmpresaContabilidadeContratacaoWebp, dominioEmpresaContaPjContratacao, dominioEmpresaContaPjContratacaoWebp, dominioEmpresaContaPjConvite, dominioEmpresaContaPjConviteWebp, } from '@ibk/shared-assets';
import { ApiProductStatus, ProductAlias } from '@ibk/shared-types';
export const createContaPjBanner = (isContracted) => ({
    id: isContracted ? 'conta-pj-convite' : 'conta-pj-contratacao',
    image: isContracted ? dominioEmpresaContaPjConvite : dominioEmpresaContaPjContratacao,
    webpImage: isContracted ? dominioEmpresaContaPjConviteWebp : dominioEmpresaContaPjContratacaoWebp,
    type: isContracted ? 'convite' : 'contratacao',
});
export const createProductBanner = (productAlias, isContracted, contractedImage, contractedWebpImage, nonContractedImage, nonContractedWebpImage, navigate) => {
    let onClick;
    if (productAlias === ProductAlias.BENEFICIOS) {
        onClick = () => {
            navigate('/beneficios');
        };
    }
    if (productAlias === ProductAlias.CONTABILIDADE_DIGITAL) {
        onClick = () => {
            navigate('/contabilidade-digital/contas-conectadas');
        };
    }
    if (productAlias === ProductAlias.COBRANCAS) {
        onClick = () => {
            navigate('/cobrancas');
        };
    }
    return {
        id: isContracted ? `${productAlias.toLowerCase()}-convite` : `${productAlias.toLowerCase()}-contratacao`,
        image: isContracted ? contractedImage : nonContractedImage,
        webpImage: isContracted ? contractedWebpImage : nonContractedWebpImage,
        type: isContracted ? 'convite' : 'contratacao',
        productAlias,
        onClick,
    };
};
const isProductAvailable = (product) => !product.isLoading && !product.error;
const isProductContracted = (product) => product.data?.status === ApiProductStatus.ACTIVE;
const isProductActive = (product) => isProductAvailable(product) && isProductContracted(product);
export const useContaPjEmpresaBanners = ({ productsData, isActive = true, hasBillingPermission, isBillingProductAvailable, }) => {
    const navigate = useNavigate();
    return useMemo(() => {
        if (!isActive) {
            return [];
        }
        const banners = [];
        const { products } = productsData;
        const contaPjProduct = products[ProductAlias.CONTA_DIGITAL];
        const hasContaPjActive = isProductActive(contaPjProduct);
        if (isProductAvailable(contaPjProduct)) {
            const isContaPjContracted = isProductContracted(contaPjProduct);
            if (!isContaPjContracted) {
                banners.push(createContaPjBanner(false));
            }
        }
        const beneficiosProduct = products[ProductAlias.BENEFICIOS];
        if (isProductAvailable(beneficiosProduct)) {
            const isBeneficiosContracted = isProductContracted(beneficiosProduct);
            if (!isBeneficiosContracted) {
                banners.push(createProductBanner(ProductAlias.BENEFICIOS, false, dominioEmpresaBeneficiosConvite, dominioEmpresaBeneficiosConviteWebp, dominioEmpresaBeneficiosContratacao, dominioEmpresaBeneficiosContratacaoWebp, navigate));
            }
        }
        const contabilidadeProduct = products[ProductAlias.CONTABILIDADE_DIGITAL];
        if (isProductAvailable(contabilidadeProduct)) {
            const isContabilidadeContracted = isProductContracted(contabilidadeProduct);
            if (isContabilidadeContracted) {
                banners.push(createProductBanner(ProductAlias.CONTABILIDADE_DIGITAL, true, dominioEmpresaContabilidadeContratacao, dominioEmpresaContabilidadeContratacaoWebp, dominioEmpresaContabilidadeContratacao, dominioEmpresaContabilidadeContratacaoWebp, navigate));
            }
        }
        const cobrancasProduct = products[ProductAlias.COBRANCAS];
        if (isProductAvailable(cobrancasProduct)) {
            const isCobrancasContracted = isProductContracted(cobrancasProduct);
            const isBillingActive = isBillingProductAvailable && isCobrancasContracted;
            if (hasBillingPermission && !isBillingActive && hasContaPjActive) {
                banners.push(createProductBanner(ProductAlias.COBRANCAS, false, dominioEmpresaCobrancasContratacao, dominioEmpresaCobrancasContratacaoWebp, dominioEmpresaCobrancasContratacao, dominioEmpresaCobrancasContratacaoWebp, navigate));
            }
        }
        return banners;
    }, [productsData, isActive, navigate, hasBillingPermission, isBillingProductAvailable]);
};
